import 'handsontable';
import formatters from '../../../Gull/Framework/formatters.js';

var HandsontableFunctions = {

	// Functie om handsontable row toe te voegen
	addRow: function(hot) {
		hot.alter('insert_row_below');
	},

	// Functie om tooltip aan te maken
	createHeaderTooltip: function(col, th, gridSettings) {
		if (gridSettings.tooltips != undefined) {
			if (gridSettings.tooltips[col] !== null) {
				var currentHelpIcon = $(th).find('.handsontable-help-icon');
				if (currentHelpIcon.length < 1) {
					var helpIcon = document.createElement('i');
					helpIcon.classList.add('handsontable-help-icon', 'fas', 'fa-question-circle', 'fa-sm', 'text-muted', 'ms-2');
				}
				var tableHeader = $(th).find('span').parent();
				tableHeader.append(helpIcon);
				tableHeader.find('.handsontable-help-icon').attr('data-toggle', 'tooltip');
				tableHeader.find('.handsontable-help-icon').attr('title', gridSettings.tooltips[col]);
				$('[data-toggle=tooltip]').tooltip();
			}
		}
	},

	// Check of het grid rows heeft
	hasRows: function(hot) {
		var rowsCount = hot.countRows();
		if (rowsCount < 1) {
			return false;
		}
		return true;
	},

	// Functie om te kijken of er cellen zijn met validatie errors
	isValid: function(hot) {
		var rowsCount = hot.countRows();
		for (var row = 0; row < rowsCount; row++) {
			var metaCols = hot.getCellMetaAtRow(row);
			if (metaCols.some(function(col) {
				return !col.valid;
			})) {
				return false;
			}
		}
		return true;
	},

	// Functie om handsontable redo te triggeren
	redo: function(hot) {
		hot.redo();
	},

	// Functie om de handsontable preloader te verwijderen
	removePreloader: function() {
		var element = document.getElementById('handsontableLoader');
		if (typeof (element) != 'undefined' && element != null) {
			element.parentNode.removeChild(element);
		}
	},

	// Functie om handsontable geselecteerde row te verwijderen
	removeRow: function(hot) {
		var selected = hot.getSelected();
		if (selected !== undefined) {
			hot.alter('remove_row', selected[0][0]);
		}
	},

	// Function to save data
	saveData: function(hot, gridStap, path, uitvraagID) {

		// Post gegevens
		$.ajax({
			type: 'POST',
			url: path + uitvraagID + '/' + 'saveToFile',
			data: {
				'dataJSON': JSON.stringify(hot.getData()),
				'dataDesc': $('[name=dataDesc]').val(),
				'dataStap': gridStap,
				'autosave': true,
			}
		});
	},

	// Functie om handsontable undo te triggeren
	undo: function(hot) {
		hot.undo();
	},

	// Functie om de data die in een sel wordt ingevoerd te formatteren
	formatAfterChange: function(changes, source, columns, hot) {

		// Wanneer het om een handmatige wijziging in een cel gaat
		if (source === 'edit') {
			HandsontableFunctions.formatData(hot, columns);

			// Wanneer er gegevens worden geplakt in het grid
		} else if (source === 'CopyPaste.paste') {
			HandsontableFunctions.formatChange(changes, hot, columns);
		}

	},

	// Format de data in een handsontable data array
	formatData: function(hot, columns) {

		// Haal de data uit het grid, itereer over rijen en kolommen en als er een formatter is gedefinieerd pas deze toe
		var data = hot.getData();
		data.forEach(function(rowContent, rowNumber) {
			rowContent.forEach(function(colContent, colNumber) {
				var formatter = columns.settings[colNumber].formatter || null;
				if (formatter !== null) {
					data[rowNumber][colNumber] = formatters[formatter](colContent);
				}
			});
		});
		// Update het grid met de nieuwe data
		hot.updateSettings({
			data: data,
		});
	},

	// Format de data in een handsontable change array
	formatChange: function(changes, hot, columns) {

		// Itereer over elke wijziging en als er een formatter is gedefinieerd pas deze toe
		changes.forEach(function([rowNumber, colNumber, oldValue, newValue]) {
			if (oldValue !== newValue) {
				var formatter = columns.settings[colNumber].formatter || null;
				if (formatter !== null) {
					var valueFormatted = formatters[formatter](newValue);
					setTimeout(function() {
						hot.setDataAtCell(rowNumber, colNumber, valueFormatted);
					}, 1);
				}
			}
		});

	},

	// Functie om handsontable disabled of enabled te maken
	disableForPaste: function(target, source, disable = true) {
		if (disable) {
			if (source === 'CopyPaste.paste') {
				$(target).addClass('opacity-75 pointer-events-none');
			}
		} else {
			setTimeout(function() {
				$(target).removeClass('opacity-75 pointer-events-none');
			}, 500);
		}
	}

};

export default HandsontableFunctions;
